import React from "react";

const LeftPaneGeneral = ({
  heightDivison,
  backToApplication,
  headingSection,
  tableHeaderSection,
  tableRowsSection,
  leftMargin,
  rightMargin
}) => {
  //const responsesDiv = useRef(null);
  const leftRightMargin = "3.5vw";
  const mainContMargin = "5vw";

  // useLayoutEffect(() => {
  //   let { scrollHeight, clientHeight } = responsesDiv.current;

  //   if (scrollHeight > clientHeight) {
  //     dispatch(changeScrollDivResponse(true));
  //   } else {
  //     dispatch(changeScrollDivResponse(false));
  //   }
  // });

  return (
    <>
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: heightDivison.backtoapp,
            alignItems: "center",
            display: "flex",
            paddingLeft: leftMargin || leftRightMargin,
            paddingRight: leftRightMargin,
            width: "100%",
          }}
        >
          {backToApplication}
        </div>
        <div
          style={{
            height: heightDivison.quoteresults,
            width: "100%",
            display: "flex",
            paddingLeft: mainContMargin,
            paddingRight: mainContMargin,
          }}
        >
          {headingSection}
        </div>
        <div
          style={{
            height: heightDivison.tableheader,
            width: "100%",
            paddingLeft: mainContMargin,
            paddingRight: mainContMargin,
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          {tableHeaderSection}
        </div>
        <div style={{ height: heightDivison.spaceBetweenHeaderContent }}></div>

        {tableRowsSection}

        <div style={{ height: heightDivison.bottommargin }}></div>
      </div>
    </>
  );
};

export default LeftPaneGeneral;
